/**
  *
  * Usage:
  *
  *   data-sw-shapejs-ide-form=<creatorId>
  *
  *
  */
 
 var ShapeJsIDEForm = require('js/lib/views/ShapeJS/ShapeJsIDEForm');
 var $ = require('js/sw-jquery/sw-jquery');

 module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-shapejs-ide-form]').each(function() {
    var $el = $(this);

    new ShapeJsIDEForm({
      el: $el
    });
  });

};
